import Service, { getCallApiFunction } from '../service'

export type RoomKolListQueryParamsType = {
  roomId: string
  status?: 0 | 1 | 2
}

type KolInfoType = {
  memberInfoId: string
  kolCoverPhoto: string
  accumulateViews: number
  headshotUrl: string
  refCode: string
  nickName: string
  intro: string
  appendix: string
  followerNum: number
  instagramUrl: string
  facebookUrl: string
  roomId: string
  kolId: string
  status: 0 | 1 | 2
  expiredAt: string
}

export type RoomKolListResponseType = {
  kolList: null | KolInfoType[]
}

class FetchRoomKolListApi extends Service {
  constructor({ roomId, status }: RoomKolListQueryParamsType) {
    super()
    this.name = 'FETCH_ROOM_KOL_LIST'

    this.config = {
      url: `/v1/livemall/member/invite/kol/${roomId}`,
      method: 'GET',
      params: { status },
    }
  }
}

export const fetchRoomKolList = (params: RoomKolListQueryParamsType): Promise<RoomKolListResponseType> =>
  getCallApiFunction(new FetchRoomKolListApi(params))
